module.exports = __webpack_public_path__ + "static/022.thumb-b15e2dd74a3206c4b9f7112c0223cbbf.jpg";